// redux/slices/userSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ActionTypesUser } from "../constants/action-types";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const REACT_APP_CHATCON_URL = process.env.REACT_APP_CHATCON_URL;

interface UserState {
    user: any;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: UserState = {
    user: null,
    status: 'idle',
    error: null,
};

// Async thunk for sign-in
export const signIn = createAsyncThunk(
    ActionTypesUser.USER_SIGN_IN_REQUEST,
    async ({ signInData, engagementParams }: { signInData: any; engagementParams: any }, { rejectWithValue }) => {
        try {
            // Replace with actual API endpoint
            const { data } = await axios.post(`${REACT_APP_CHATCON_URL}/createSession`, signInData);

            // Add additional fields with UUIDs for unique identification
            const userData = { ...data, providerSenderId: uuidv4(), providerDialogId: uuidv4() };
            return { userData, engagementParams };
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to sign in');
        }
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user = action.payload.userData;
                state.error = null;
            })
            .addCase(signIn.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const selectUser = (state: { user: UserState }) => state.user.user;
export const selectUserStatus = (state: { user: UserState }) => state.user.status;
export const selectUserError = (state: { user: UserState }) => state.user.error;

export default userSlice.reducer;
